import React, { useEffect } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import AnimatedBackground from '@/components/AnimatedBackground';
import { useLanguage } from '@/App';

const PrivacyPolicyPage = () => {
  const { language } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const content = {
    tr: {
      title: 'GİZLİLİK POLİTİKASI VE KVKK AYDINLATMA METNİ',

      // Hukuki disclaimer — TR metni baglayici, EN bilgi amacli
      legalDisclaimer: 'Bu metnin İngilizce versiyonu yalnızca bilgilendirme amaçlıdır. Hukuki olarak bağlayıcı tek metin Türkçe versiyondur. Herhangi bir çelişki veya yorum farkı durumunda Türkçe metin esas alınır.',

      // === KVKK Aydinlatma Metni (yeni — sayfanin ustunde) ===
      kvkk_title: 'KVKK Aydınlatma Metni',

      // Veri Sorumlusu bilgileri (numarasiz bilgi karti)
      kvkk_dataControllerTitle: 'Veri Sorumlusu Bilgileri',
      kvkk_dataControllerItems: [
        'Şirket Adı: PERSONA ORGANİZASYON TİCARET LİMİTED ŞİRKETİ ("Persona Ajans")',
        'Adres: Zekeriyaköy Mah. Erguvanlı Cad. Ariköy Sitesi 28 No: 29 Sarıyer İstanbul',
        'Vergi Dairesi: Sarıyer',
        'Vergi Numarası: 7280821743',
        'MERSİS No: 728082174300001',
        'İletişim: info@personaajans.com',
      ],
      kvkk_introText: 'Bu Aydınlatma Metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, Veri Sorumlusu olan Persona Ajans tarafından, influencer ("İlgili Kişi") başvurunuz sırasında bu dijital form aracılığıyla toplanan kişisel verilerinizin işlenmesine ilişkin usul ve esaslar hakkında sizi bilgilendirmek amacıyla hazırlanmıştır.',

      // 1. Islenen Kisisel Veriler
      kvkk_sec1Title: '1. İşlenen Kişisel Verileriniz ve Toplanma Yöntemi',
      kvkk_sec1Intro: 'Bu başvuru formu aracılığıyla otomatik yollarla toplanan kişisel verileriniz kategorik olarak şunlardır:',
      kvkk_sec1Items: [
        'Kimlik Bilgileri: Ad, soyad, doğum yılı.',
        'İletişim Bilgileri: Telefon/WhatsApp numarası, e-posta adresi.',
        'Lokasyon Bilgileri: Yaşadığınız ülke ve şehir (Türkiye\'de yaşayanlar için 81 il dropdown, yurt dışı için serbest metin).',
        'Demografik Bilgiler: Annelik durumu (anne, anne adayı, çocuksuz), çocuklarınızın doğum ay ve yılları.',
        'Özel Nitelikli Kişisel Veriler (Sağlık Verisi): Anne adayları için mevcut hamilelik durumu ve beklenen doğum tarihi; anne kullanıcılar için yeni hamilelik durumu (varsa). KVKK Madde 6 kapsamında özel nitelikli kişisel veri olarak değerlendirilmektedir.',
        'Profesyonel/Mesleki Veriler: Aktif olduğunuz sosyal medya platformları (Instagram, TikTok ve diğer platformlar — YouTube, X, Podcast vb.), her platform için kullanıcı adı/URL, takipçi sayısı aralığı, içerik görüntülenme istatistikleri (Instagram Story/Reel, TikTok Video), ürettiğiniz içerik kategorileri (niş).',
        'Finansal Bilgiler: Bütçe beklentiniz (Instagram Story, Reel ve TikTok Video için talep ettiğiniz ücret aralıkları — TRY cinsinden).',
        'Tercih Bilgileri: Ürün/hizmet karşılığı (barter) iş birliklerine açıklık tercihiniz ve Persona PR Grubu üyeliğine ilgi durumunuz (yalnızca Türkiye\'de yaşayanlar için).',
      ],

      // 2. Isleme Amaclari ve Hukuki Sebepler (4 alt-bolum: a, b, c, c)
      kvkk_sec2Title: '2. Kişisel Verilerin İşlenme Amaçları ve Hukuki Sebepleri',
      kvkk_sec2Intro: 'Kişisel verileriniz, KVKK\'nın 5. ve 6. maddesinde belirtilen hukuki sebeplere dayalı olarak aşağıdaki amaçlarla işlenecektir:',
      kvkk_sec2aTitle: 'a) Bir Sözleşmenin Kurulması veya İfası (KVKK Mad. 5/2-c)',
      kvkk_sec2aText: 'Sizinle (Influencer) aramızdaki ajans-influencer hizmet ilişkisinin (sözleşmesinin) kurulması ve yürütülmesi amacıyla;',
      kvkk_sec2aItems: [
        'Influencer havuzumuza kaydınızın alınması, doğrulanması ve yönetilmesi,',
        'Marka müşterilerimizin kampanya hedeflerine (hedef kitle, bütçe, içerik) uygunluğunuzun değerlendirilmesi (Aday Değerlendirme),',
        'Potansiyel iş birliği teklifleri ve projeler hakkında sizinle iletişim kurulması.',
      ],
      kvkk_sec2bTitle: 'b) Açık Rızanız (KVKK Mad. 5/1 ve Mad. 6/3)',
      kvkk_sec2bText: 'Aşağıdaki amaçlar için açık rızanız esas alınmaktadır:',
      kvkk_sec2bItems: [
        'İş birliği yapılacak Markalara, hizmet sunumu ve kampanya değerlendirmesi amacıyla profil bilgilerinizin (kullanıcı adı, istatistikler, bütçe beklentisi vb.) sunulması,',
        'Yeni proje ve işbirliği fırsatları konusunda tarafınızla iletişim kurulması (pazarlama iletişimi),',
        'Özel nitelikli kişisel veriniz olan hamilelik durumunuzun, yalnızca anne-bebek/hamilelik odaklı spesifik marka kampanyalarına uygunluğunuzun değerlendirilmesi amacıyla işlenmesi (KVKK Madde 6/3 kapsamında),',
        'Verilerinizin, ajansın operasyonlarını yürütmek için teknik altyapı hizmeti aldığı (bulut sunucu, veri tabanı, e-posta, CRM gibi) sistemlerin yurt dışında mukim olması sebebiyle yurt dışına aktarılmasına ve orada saklanmasına (KVKK Madde 9 kapsamında).',
      ],
      kvkk_sec2cTitle: 'c) Veri Sorumlusunun Meşru Menfaatleri (KVKK Mad. 5/2-f)',
      kvkk_sec2cText: 'Ajansımızın operasyonel süreçlerini yürütmek kapsamındaki meşru menfaatlerimiz için;',
      kvkk_sec2cItems: [
        'Müşteri (Marka) portföyümüze sunum yapmak amacıyla influencer portföyümüzün listelenmesi ve segmente edilmesi,',
        'İç raporlama ve iş geliştirme faaliyetlerinin yürütülmesi.',
      ],
      kvkk_sec2dTitle: 'ç) Hukuki Yükümlülüklerin Yerine Getirilmesi (KVKK Mad. 5/2-ç)',
      kvkk_sec2dText: 'Yetkili kamu kurum ve kuruluşlarının talepleri veya yasal uyuşmazlıklar halinde ilgili mercilere yasal bildirimlerin yapılması.',

      // 3. Aktarma (Yurtici + Yurtdisi)
      kvkk_sec3Title: '3. Kişisel Verilerin Aktarılması (Yurtiçi ve Yurtdışı)',
      kvkk_sec3Intro: 'Toplanan kişisel verileriniz, yukarıda (Madde 2) belirtilen hukuki sebepler ve amaçlar doğrultusunda, gerekli güvenlik önlemleri alınarak;',
      kvkk_sec3Items: [
        'Markalara (Müşteriler): İşbirliği fırsatlarının değerlendirilmesi ve kampanya süreçlerinin yürütülmesi amacıyla, ajansımızın hizmet verdiği veya potansiyel olarak hizmet vereceği kurumsal müşterilere ("Markalar"), açık rızanıza dayalı olarak,',
        'Yurtiçi Tedarikçi ve İş Ortaklarına: Faaliyetlerimizi yürütmek için teknik destek aldığımız Türkiye\'de mukim teknoloji tedarikçilerine,',
        'Yurtdışındaki Teknoloji Tedarikçilerine (KVKK Madde 9): Bulut sunucu, veri tabanı barındırma, e-posta gönderim ve CRM hizmetleri için yurt dışında mukim teknoloji tedarikçilerine (örn: Google Cloud, MongoDB Atlas, Mailgun). Bu aktarım, 12 Mart 2024 tarihinde değişen KVKK Madde 9 uyarınca açık rızanıza veya Standart Sözleşme\'ye dayalı olarak gerçekleştirilmektedir,',
        'Yetkili Kamu Kurumlarına: Yasal bir zorunluluk olması halinde, talep üzerine yetkili kamu kurum ve kuruluşlarına aktarılabilecektir.',
      ],

      // 4. Saklama Suresi
      kvkk_sec4Title: '4. Kişisel Verilerin Saklanma Süresi',
      kvkk_sec4Intro: 'Kişisel verileriniz, KVKK\'nın "veri minimizasyonu" ve "süreyle sınırlılık" ilkelerine uygun olarak aşağıdaki şekilde saklanacaktır:',
      kvkk_sec4Items: [
        'Aktif İlişki Süresi: Persona Ajans ile aranızdaki \'influencer-ajans\' ilişkiniz veya influencer havuzumuzda kalma tercihiniz devam ettiği sürece.',
        'Sözleşmesel Faaliyet Olmaması Halinde: Ajansımızla ticari/sözleşmesel bir faaliyet yürütülmemesi halinde verileriniz başvurunuzdan itibaren 2 (iki) yıl sonunda imha edilecektir.',
        'Sözleşmesel Faaliyet Olması Halinde: Herhangi bir marka iş birliği kapsamında sözleşme kurulması ve ticari ilişki doğması halinde, kişisel verileriniz yasal yükümlülüklerimiz ve olası uyuşmazlıklara karşı ispat amacıyla Türk Ticaret Kanunu ve Borçlar Kanunu uyarınca sözleşme bitiminden itibaren 10 (on) yıl süreyle saklanacaktır.',
      ],
      kvkk_sec4Note: 'Açık rızaya dayalı işlemeler için, açık rızanızı her zaman info@personaajans.com adresine yazılı talep ile geri çekebilirsiniz. Açık rıza geri çekilmesi halinde, açık rızaya dayalı işlemeler durdurulur, ancak diğer hukuki sebeplere (sözleşme, meşru menfaat, hukuki yükümlülük) dayalı işlemeler devam edebilir.',

      // 5. Haklar (KVKK Md. 11)
      kvkk_sec5Title: '5. İlgili Kişi Olarak Haklarınız (KVKK Madde 11)',
      kvkk_sec5Text: 'Kişisel veri sahibi olarak KVKK\'nın 11. maddesi uyarınca aşağıdaki haklara sahipsiniz:',
      kvkk_sec5Items: [
        'Kişisel verilerinizin işlenip işlenmediğini öğrenme,',
        'İşlenmişse buna ilişkin bilgi talep etme,',
        'İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme,',
        'Yurtiçinde veya yurtdışında verilerin aktarıldığı üçüncü kişileri bilme,',
        'Eksik veya yanlış işlenmişse düzeltilmesini isteme,',
        'KVKK\'nın 7. maddesinde öngörülen şartlar çerçevesinde kişisel verilerin silinmesini veya yok edilmesini isteme,',
        'Yapılan düzeltme, silme veya yok etme işlemlerinin, verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,',
        'İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme,',
        'Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme.',
      ],

      // 6. Basvuru Yontemleri ve Kimlik Dogrulama
      kvkk_sec6Title: '6. Başvuru Yöntemleri ve Kimlik Doğrulama',
      kvkk_sec6Intro: 'Yukarıda sayılan haklarınızı kullanmak için taleplerinizi, Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğ\'e uygun olarak aşağıdaki yöntemlerden biri ile iletebilirsiniz:',
      kvkk_sec6Items: [
        'E-posta: Sistemimizde kayıtlı bulunan e-posta adresinizi kullanarak info@personaajans.com adresine,',
        'Posta/Noter: Kimliğinizi tevsik edici belgelerle birlikte, noter kanalıyla şirket adresimize (Zekeriyaköy Mah. Erguvanlı Cad. Ariköy Sitesi 28 No: 29 Sarıyer İstanbul),',
        'Güvenli Elektronik İmza: KEP adresi veya güvenli elektronik imza ile doğrulanmış başvuru olarak.',
      ],
      kvkk_sec6Note: 'Kimlik doğrulama, başkası adına yapılan haksız taleplerin önüne geçmek için zorunludur. Başvurunuz en geç 30 gün içinde sonuçlandırılacaktır.',

      // === Acik Riza Beyani (yeni — sayfanin altinda, anchor'li) ===
      acikRiza_title: 'Açık Rıza Beyanı',
      acikRiza_intro: 'Influencer başvuru formunu doldururken işaretlediğiniz "Açık Rıza" kutucuğunun tam metni:',
      acikRiza_text: 'Kişisel verilerimin (ad-soyad, iletişim bilgileri, sosyal medya hesap bilgileri, demografik bilgiler, fiyat bilgileri) ve KVKK Madde 6 kapsamında özel nitelikli kişisel veri sayılan hamilelik durumu bilgilerimin PERSONA ORGANİZASYON TİCARET LİMİTED ŞİRKETİ tarafından:\n\n(a) Influencer veritabanına alınması,\n(b) Marka kampanyalarına uygunluğumun değerlendirilmesi ve sunulması amacıyla profil bilgilerimin ilgili markalara/müşterilere aktarılması,\n(c) Yeni proje ve işbirliği fırsatları konusunda tarafımla iletişim kurulması,\n(ç) Özel nitelikli kişisel verim olan hamilelik durumumun, yalnızca anne-bebek/hamilelik odaklı spesifik marka kampanyalarına uygunluğumun değerlendirilmesi amacıyla işlenmesi (KVKK Madde 6/3 kapsamında),\n(d) Verilerimin, ajansın operasyonlarını yürütmek için teknik altyapı hizmeti aldığı (bulut sunucu, veri tabanı, e-posta, CRM gibi) sistemlerin yurt dışında mukim olması sebebiyle yurt dışına aktarılmasına ve orada saklanmasına (KVKK Madde 9 kapsamında)\n\namaçlarıyla işlenmesine ve aktarılmasına açık rıza veriyorum.',
      acikRiza_note: 'Açık rızanızı her zaman info@personaajans.com adresine yazılı talep ile geri çekebilirsiniz.',
      acikRiza_textVersion: 'Metin Versiyonu: v1.0',

      companyInfo: 'Veri Sorumlusu: PERSONA ORGANİZASYON TİCARET LİMİTED ŞİRKETİ ("Persona Ajans")',
      address: 'Adres: Zekeriyaköy Mah. Erguvanlı Cad. Ariköy Sitesi 28 No: 29 Sarıyer İstanbul',
      mersis: 'MERSİS No: 728082174300001',
      intro: 'Bu Gizlilik Politikası ve Aydınlatma Metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, reklam ve pazarlama faaliyetlerimiz (LinkedIn lead formları, web sitesi iletişim formları vb.) aracılığıyla bizimle iletişime geçen potansiyel müşteri ve iş ortaklarımızın ("İlgili Kişi") kişisel verilerinin işlenmesine ilişkin usul ve esasları belirlemektedir.',
      
      section1Title: '1. İşlenen Kişisel Verileriniz ve Toplanma Yöntemi',
      section1Text: 'Dijital formlar (LinkedIn Lead Gen formları vb.), web sitemiz veya e-posta aracılığıyla otomatik yollarla toplanan kişisel verileriniz şunlardır:',
      section1Items: [
        'Kimlik Bilgileri: Adınız, Soyadınız.',
        'İletişim Bilgileri: E-posta adresiniz, Telefon numaranız.',
        'Mesleki/Kurumsal Bilgiler: Şirket adınız, Unvanınız/Pozisyonunuz.'
      ],
      
      section2Title: '2. Kişisel Verilerin İşlenme Amaçları ve Hukuki Sebepleri',
      section2Text: 'Kişisel verileriniz, KVKK\'nın 5. maddesi uyarınca "Bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili olması" (Mad. 5/2-c) ve "Veri sorumlusunun meşru menfaatleri" (Mad. 5/2-f) hukuki sebeplerine dayalı olarak aşağıdaki amaçlarla işlenmektedir:',
      section2Items: [
        'Talep ettiğiniz influencer pazarlaması hizmetleri hakkında size bilgi verilmesi ve teklif sunulması,',
        'Şirketinizle potansiyel iş ilişkisinin ve sözleşmenin kurulması için gerekli iletişimin sağlanması,',
        'Pazarlama ve müşteri ilişkileri yönetimi süreçlerinin yürütülmesi,',
        'Kurumsal iletişim faaliyetlerinin planlanması ve icrası.'
      ],
      
      section3Title: '3. Kişisel Verilerin Aktarılması',
      section3Text: 'Toplanan kişisel verileriniz, kural olarak üçüncü kişilerle paylaşılmamaktadır. Ancak faaliyetlerimizi yürütmek için teknik destek aldığımız (sunucu, bulut depolama, CRM yazılımı) tedarikçilerimizle ve yasal bir zorunluluk olması halinde yetkili kamu kurum ve kuruluşlarıyla sınırlı olarak paylaşılabilecektir.',
      
      section4Title: '4. Kişisel Verilerin Saklanma Süresi',
      section4Text: 'Kişisel verileriniz, tarafımızla ticari ilişkiniz kurulmadığı takdirde talebinizin sonuçlandırılmasından itibaren 1 (bir) yıl süreyle; ticari ilişki kurulması halinde ise ilgili yasal mevzuatlarda öngörülen zamanaşımı süreleri boyunca güvenle saklanacaktır.',
      
      section5Title: '5. İlgili Kişi Olarak Haklarınız',
      section5Text: 'KVKK\'nın 11. maddesi uyarınca aşağıdaki haklara sahipsiniz:',
      section5Items: [
        'Kişisel verilerinizin işlenip işlenmediğini öğrenme,',
        'İşlenmişse buna ilişkin bilgi talep etme,',
        'İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme,',
        'Yurtiçinde veya yurtdışında verilerin aktarıldığı üçüncü kişileri bilme,',
        'Eksik veya yanlış işlenmişse düzeltilmesini isteme,',
        'KVKK\'nın 7. maddesinde öngörülen şartlar çerçevesinde silinmesini veya yok edilmesini isteme,',
        'İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme,',
        'Kanuna aykırı işlenmesi sebebiyle zarara uğramanız halinde zararın giderilmesini talep etme.'
      ],
      
      section6Title: '6. Başvuru Yöntemi',
      section6Text: 'Yukarıda sayılan haklarınızı kullanmak için taleplerinizi info@personaajans.com e-posta adresine iletebilirsiniz.',
      
      lastUpdate: 'Son güncelleme: Mayıs 2026 — Metin Versiyonu: v1.0'
    },
    en: {
      title: 'PRIVACY POLICY AND KVKK INFORMATION TEXT',

      // Legal disclaimer — TR text is binding, EN provided for information only
      legalDisclaimer: 'The English version of this text is provided for informational purposes only. The Turkish version is the only legally binding version. In case of any discrepancy or conflict between the English and Turkish versions, the Turkish version shall prevail.',

      // === KVKK Information Text (new — top of page) ===
      kvkk_title: 'KVKK Information Text (Turkish Personal Data Protection Law)',

      // Data Controller info (numberless info card)
      kvkk_dataControllerTitle: 'Data Controller Information',
      kvkk_dataControllerItems: [
        'Company Name: PERSONA ORGANİZASYON TİCARET LİMİTED ŞİRKETİ ("Persona Agency")',
        'Address: Zekeriyaköy Mah. Erguvanlı Cad. Ariköy Sitesi 28 No: 29 Sarıyer İstanbul, Türkiye',
        'Tax Office: Sarıyer',
        'Tax ID: 7280821743',
        'MERSIS No: 728082174300001',
        'Contact: info@personaajans.com',
      ],
      kvkk_introText: 'This Information Text has been prepared, pursuant to the Turkish Personal Data Protection Law No. 6698 ("KVKK"), to inform you, as the Data Controller Persona Agency, regarding the procedures and principles for processing your personal data collected through this digital form during your influencer ("Data Subject") application.',

      // 1. Personal Data Processed
      kvkk_sec1Title: '1. Your Personal Data Being Processed and Collection Method',
      kvkk_sec1Intro: 'The personal data automatically collected through this application form fall into the following categories:',
      kvkk_sec1Items: [
        'Identity Information: First name, last name, birth year.',
        'Contact Information: Phone/WhatsApp number, email address.',
        'Location Information: Country and city of residence (81-province dropdown for residents of Türkiye, free text for international users).',
        'Demographic Information: Motherhood status (mom, mom-to-be, no children), birth months and years of your children.',
        'Special Category Personal Data (Health Data): Current pregnancy status and expected due date for mom-to-be users; new pregnancy status (if any) for mom users. Considered special category personal data under KVKK Article 6.',
        'Professional/Vocational Data: Active social media platforms (Instagram, TikTok and other platforms — YouTube, X, Podcast, etc.), username/URL for each platform, follower count range, content view statistics (Instagram Story/Reel, TikTok Video), content categories (niche) you produce.',
        'Financial Information: Your budget expectations (price ranges you request for Instagram Story, Reel and TikTok Video — in TRY).',
        'Preference Information: Your openness to product/service-based (barter) collaborations and your interest in Persona PR Group membership (only for residents of Türkiye).',
      ],

      // 2. Processing Purposes and Legal Basis (4 sub-sections: a, b, c, d)
      kvkk_sec2Title: '2. Purposes and Legal Grounds for Processing Personal Data',
      kvkk_sec2Intro: 'Your personal data will be processed for the following purposes based on the legal grounds set out in Articles 5 and 6 of the KVKK:',
      kvkk_sec2aTitle: 'a) Establishment or Performance of a Contract (KVKK Art. 5/2-c)',
      kvkk_sec2aText: 'For the purpose of establishing and performing the agency-influencer service relationship (contract) between us;',
      kvkk_sec2aItems: [
        'Recording, verifying and managing your registration in our influencer pool,',
        'Evaluating your suitability for our brand clients\' campaign objectives (target audience, budget, content) — Candidate Evaluation,',
        'Contacting you regarding potential collaboration offers and projects.',
      ],
      kvkk_sec2bTitle: 'b) Your Explicit Consent (KVKK Art. 5/1 and Art. 6/3)',
      kvkk_sec2bText: 'Your explicit consent is the basis for the following purposes:',
      kvkk_sec2bItems: [
        'Sharing your profile information (username, statistics, budget expectations, etc.) with Brands for service delivery and campaign evaluation,',
        'Contacting you regarding new project and collaboration opportunities (marketing communication),',
        'Processing your special category personal data (pregnancy status) solely for evaluating your suitability for mom-baby/pregnancy-focused brand campaigns (under KVKK Art. 6/3),',
        'Transfer and storage of your data abroad due to the international location of the technical infrastructure providers (cloud servers, databases, email, CRM, etc.) used for the agency\'s operations (under KVKK Art. 9).',
      ],
      kvkk_sec2cTitle: 'c) Legitimate Interests of the Data Controller (KVKK Art. 5/2-f)',
      kvkk_sec2cText: 'For our legitimate interests in conducting our agency\'s operational processes;',
      kvkk_sec2cItems: [
        'Listing and segmenting our influencer portfolio for the purpose of pitching to our client (Brand) portfolio,',
        'Conducting internal reporting and business development activities.',
      ],
      kvkk_sec2dTitle: 'd) Fulfillment of Legal Obligations (KVKK Art. 5/2-ç)',
      kvkk_sec2dText: 'Making legal notifications to relevant authorities upon requests of authorized public institutions or in case of legal disputes.',

      // 3. Transfer (Domestic + International)
      kvkk_sec3Title: '3. Transfer of Personal Data (Domestic and International)',
      kvkk_sec3Intro: 'Your collected personal data, in line with the legal grounds and purposes specified above (Article 2), with appropriate security measures, may be transferred to:',
      kvkk_sec3Items: [
        'Brands (Clients): To corporate clients ("Brands") that our agency serves or potentially will serve, based on your explicit consent, for the purpose of evaluating collaboration opportunities and conducting campaign processes,',
        'Domestic Suppliers and Business Partners: To technology suppliers based in Türkiye that we receive technical support from to conduct our activities,',
        'International Technology Suppliers (KVKK Art. 9): To technology suppliers based abroad for cloud servers, database hosting, email delivery and CRM services (e.g. Google Cloud, MongoDB Atlas, Mailgun). This transfer is carried out based on your explicit consent or Standard Contractual Clauses, in accordance with KVKK Art. 9 as amended on 12 March 2024,',
        'Authorized Public Institutions: In case of legal obligation, to authorized public institutions and organizations upon request.',
      ],

      // 4. Retention Period
      kvkk_sec4Title: '4. Retention Period of Personal Data',
      kvkk_sec4Intro: 'Your personal data will be retained in accordance with KVKK\'s "data minimization" and "limitation of duration" principles as follows:',
      kvkk_sec4Items: [
        'Active Relationship Period: For the duration of the \'influencer-agency\' relationship between you and Persona Agency or your preference to remain in our influencer pool.',
        'Absence of Contractual Activity: If no commercial/contractual activity is carried out with our agency, your data will be destroyed at the end of 2 (two) years from your application.',
        'Existence of Contractual Activity: If a contract is concluded within the scope of any brand collaboration and a commercial relationship arises, your personal data will be retained for 10 (ten) years from the end of the contract for our legal obligations and to provide evidence against potential disputes, in accordance with the Turkish Commercial Code and the Code of Obligations.',
      ],
      kvkk_sec4Note: 'For processing based on explicit consent, you can withdraw your explicit consent at any time by sending a written request to info@personaajans.com. Upon withdrawal, processing based on explicit consent will be stopped; however, processing based on other legal grounds (contract, legitimate interest, legal obligation) may continue.',

      // 5. Rights (KVKK Art. 11)
      kvkk_sec5Title: '5. Your Rights as a Data Subject (KVKK Article 11)',
      kvkk_sec5Text: 'As a personal data owner, you have the following rights pursuant to Article 11 of the KVKK:',
      kvkk_sec5Items: [
        'To learn whether your personal data is being processed,',
        'To request information if it has been processed,',
        'To learn the purpose of processing and whether it is used in accordance with its purpose,',
        'To know the third parties to whom the data has been transferred domestically or abroad,',
        'To request correction if processed incompletely or incorrectly,',
        'To request the deletion or destruction of personal data within the framework of the conditions stipulated in Article 7 of the KVKK,',
        'To request that the correction, deletion or destruction operations be notified to the third parties to whom the data has been transferred,',
        'To object to a result against you arising from analysis of processed data exclusively by automated systems,',
        'To request compensation for damages in case you suffer damages due to the unlawful processing of personal data.',
      ],

      // 6. Application Methods and Identity Verification
      kvkk_sec6Title: '6. Application Methods and Identity Verification',
      kvkk_sec6Intro: 'To exercise your rights listed above, you can submit your requests, in accordance with the Communiqué on the Procedures and Principles for Application to the Data Controller, by one of the following methods:',
      kvkk_sec6Items: [
        'Email: To info@personaajans.com using the email address registered in our system,',
        'Mail/Notary: To our company address (Zekeriyaköy Mah. Erguvanlı Cad. Ariköy Sitesi 28 No: 29 Sarıyer İstanbul) via notary, together with documents proving your identity,',
        'Secure Electronic Signature: As an application verified with a registered electronic mail (KEP) address or secure electronic signature.',
      ],
      kvkk_sec6Note: 'Identity verification is mandatory to prevent unjust requests made on behalf of others. Your application will be finalized within a maximum of 30 days.',

      // === Explicit Consent Statement (new — bottom of page, anchor) ===
      acikRiza_title: 'Explicit Consent Statement',
      acikRiza_intro: 'Full text of the "Explicit Consent" checkbox you marked when filling out the influencer application form:',
      acikRiza_text: 'I give my explicit consent for my personal data (full name, contact information, social media account information, demographic information, price information) and my pregnancy status information considered as special category personal data under KVKK Article 6, to be processed and transferred by PERSONA ORGANİZASYON TİCARET LİMİTED ŞİRKETİ for the following purposes:\n\n(a) Inclusion in the influencer database,\n(b) Transfer of my profile information to relevant brands/clients for the purpose of evaluation and presentation regarding suitability for brand campaigns,\n(c) Contacting me regarding new project and collaboration opportunities,\n(d) Processing my special category personal data (pregnancy status) solely for evaluating my suitability for mom-baby/pregnancy-focused brand campaigns (under KVKK Article 6/3),\n(e) Transfer and storage of my data abroad due to the international location of the technical infrastructure providers (cloud servers, databases, email, CRM) used for the agency\'s operations (under KVKK Article 9).',
      acikRiza_note: 'You can withdraw your explicit consent at any time by sending a written request to info@personaajans.com.',
      acikRiza_textVersion: 'Text Version: v1.0',

      companyInfo: 'Data Controller: PERSONA ORGANİZASYON TİCARET LİMİTED ŞİRKETİ ("Persona Agency")',
      address: 'Address: Zekeriyaköy Mah. Erguvanlı Cad. Ariköy Sitesi 28 No: 29 Sarıyer Istanbul',
      mersis: 'MERSIS No: 728082174300001',
      intro: 'This Privacy Policy and Information Text determines the procedures and principles regarding the processing of personal data of potential customers and business partners ("Data Subject") who contact us through our advertising and marketing activities (LinkedIn lead forms, website contact forms, etc.) in accordance with the Personal Data Protection Law No. 6698 ("KVKK").',
      
      section1Title: '1. Your Personal Data Being Processed and Collection Method',
      section1Text: 'Your personal data collected automatically through digital forms (LinkedIn Lead Gen forms, etc.), our website or e-mail are as follows:',
      section1Items: [
        'Identity Information: Your Name, Surname.',
        'Contact Information: Your Email address, Phone number.',
        'Professional/Corporate Information: Your Company name, Title/Position.'
      ],
      
      section2Title: '2. Purposes and Legal Grounds for Processing Personal Data',
      section2Text: 'Your personal data is processed for the following purposes based on the legal grounds of "Being directly related to the establishment or performance of a contract" (Art. 5/2-c) and "Legitimate interests of the data controller" (Art. 5/2-f) under Article 5 of the KVKK:',
      section2Items: [
        'Providing information and offers about the influencer marketing services you request,',
        'Ensuring necessary communication for establishing potential business relationship and contract with your company,',
        'Conducting marketing and customer relationship management processes,',
        'Planning and execution of corporate communication activities.'
      ],
      
      section3Title: '3. Transfer of Personal Data',
      section3Text: 'Your collected personal data is not shared with third parties as a rule. However, it may be shared limitedly with our suppliers from whom we receive technical support (server, cloud storage, CRM software) to conduct our activities and with authorized public institutions in case of legal obligation.',
      
      section4Title: '4. Storage Period of Personal Data',
      section4Text: 'Your personal data will be securely stored for 1 (one) year from the conclusion of your request if a commercial relationship is not established with us; and for the statute of limitations periods stipulated in relevant legal legislation if a commercial relationship is established.',
      
      section5Title: '5. Your Rights as a Data Subject',
      section5Text: 'You have the following rights under Article 11 of the KVKK:',
      section5Items: [
        'To learn whether your personal data is being processed,',
        'To request information if it has been processed,',
        'To learn the purpose of processing and whether it is used in accordance with its purpose,',
        'To know the third parties to whom the data is transferred domestically or abroad,',
        'To request correction if processed incompletely or incorrectly,',
        'To request deletion or destruction within the framework of conditions stipulated in Article 7 of the KVKK,',
        'To object to a result against you through analysis of processed data exclusively by automated systems,',
        'To request compensation for damages in case of damage due to illegal processing.'
      ],
      
      section6Title: '6. Application Method',
      section6Text: 'To exercise your rights listed above, you can send your requests to info@personaajans.com.',
      
      lastUpdate: 'Last updated: May 2026 — Text Version: v1.0'
    }
  };

  const t = content[language];

  return (
    <div className="min-h-screen bg-black relative flex flex-col">
      <AnimatedBackground />
      <div className="relative z-10 flex flex-col min-h-screen">
        <Navbar />
        
        <div className="flex-1 px-4 pt-32 pb-16 bg-black bg-opacity-75">
          <div className="max-w-4xl mx-auto">
            {/* Title */}
            <h1 className="text-2xl md:text-3xl font-bold text-[#FFDD59] mb-8 text-center">
              {t.title}
            </h1>

            {/* Hukuki disclaimer — sadece EN sayfasinda gosterilir.
                TR okuyucu zaten asil/baglayici metni okuyor; uyari yalnizca EN okuyana anlamli
                ("Turkish version shall prevail"). TR icin gosterilmesi anlamsizdi.
                NOT: TR content'inde legalDisclaimer key'i backward-compat icin korundu (dead key, zarar vermez). */}
            {language === 'en' && (
              <div className="bg-blue-500/10 border-l-4 border-blue-400 p-4 rounded-r-lg my-6" role="note">
                <div className="flex items-start gap-3">
                  <span className="text-blue-400 text-xl flex-shrink-0" aria-hidden="true">ℹ️</span>
                  <p className="text-sm text-gray-300 leading-relaxed">
                    <strong className="text-blue-400">Important Legal Notice:</strong>
                    {' '}
                    {t.legalDisclaimer}
                  </p>
                </div>
              </div>
            )}

            {/* === KVKK Aydinlatma Metni (Gemini avukat tavsiyelerine gore — Mayis 2026 v1.0) === */}
            {/* Yapi: Veri Sorumlusu (numarasiz) + giris paragrafi + 6 numerali section */}
            <div className="mb-10">
              <h2 className="text-xl md:text-2xl font-bold text-[#FFDD59] mb-4">{t.kvkk_title}</h2>

              {/* Veri Sorumlusu Bilgileri (numarasiz) */}
              <div className="mb-6 bg-gray-900/50 border border-gray-700 p-6 rounded-lg">
                <h3 className="text-lg font-bold text-[#FFDD59] mb-3">{t.kvkk_dataControllerTitle}</h3>
                <ul className="space-y-2 text-gray-300 mb-4">
                  {t.kvkk_dataControllerItems.map((item, index) => (
                    <li key={index} className="flex items-start">
                      <span className="text-[#FFDD59] mr-2">—</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
                <p className="text-gray-300 leading-relaxed pt-3 border-t border-gray-700">{t.kvkk_introText}</p>
              </div>

              {/* 1. Islenen Kisisel Veriler */}
              <div className="mb-6 bg-gray-900/50 border border-gray-700 p-6 rounded-lg">
                <h3 className="text-lg font-bold text-[#FFDD59] mb-3">{t.kvkk_sec1Title}</h3>
                <p className="text-gray-300 mb-3">{t.kvkk_sec1Intro}</p>
                <ul className="space-y-2 text-gray-300">
                  {t.kvkk_sec1Items.map((item, index) => (
                    <li key={index} className="flex items-start">
                      <span className="text-[#FFDD59] mr-2">—</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* 2. Isleme Amaclari ve Hukuki Sebepler (4 alt-bolum a/b/c/c) */}
              <div className="mb-6 bg-gray-900/50 border border-gray-700 p-6 rounded-lg">
                <h3 className="text-lg font-bold text-[#FFDD59] mb-3">{t.kvkk_sec2Title}</h3>
                <p className="text-gray-300 mb-4">{t.kvkk_sec2Intro}</p>

                {/* a) */}
                <h4 className="text-base font-semibold text-[#FFDD59]/90 mt-4 mb-2">{t.kvkk_sec2aTitle}</h4>
                <p className="text-gray-300 mb-2">{t.kvkk_sec2aText}</p>
                <ul className="space-y-2 text-gray-300 mb-4">
                  {t.kvkk_sec2aItems.map((item, index) => (
                    <li key={index} className="flex items-start">
                      <span className="text-[#FFDD59] mr-2">—</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>

                {/* b) */}
                <h4 className="text-base font-semibold text-[#FFDD59]/90 mt-4 mb-2">{t.kvkk_sec2bTitle}</h4>
                <p className="text-gray-300 mb-2">{t.kvkk_sec2bText}</p>
                <ul className="space-y-2 text-gray-300 mb-4">
                  {t.kvkk_sec2bItems.map((item, index) => (
                    <li key={index} className="flex items-start">
                      <span className="text-[#FFDD59] mr-2">—</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>

                {/* c) */}
                <h4 className="text-base font-semibold text-[#FFDD59]/90 mt-4 mb-2">{t.kvkk_sec2cTitle}</h4>
                <p className="text-gray-300 mb-2">{t.kvkk_sec2cText}</p>
                <ul className="space-y-2 text-gray-300 mb-4">
                  {t.kvkk_sec2cItems.map((item, index) => (
                    <li key={index} className="flex items-start">
                      <span className="text-[#FFDD59] mr-2">—</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>

                {/* c) Hukuki Yukumluluk */}
                <h4 className="text-base font-semibold text-[#FFDD59]/90 mt-4 mb-2">{t.kvkk_sec2dTitle}</h4>
                <p className="text-gray-300">{t.kvkk_sec2dText}</p>
              </div>

              {/* 3. Aktarma (Yurtici + Yurtdisi) */}
              <div className="mb-6 bg-gray-900/50 border border-gray-700 p-6 rounded-lg">
                <h3 className="text-lg font-bold text-[#FFDD59] mb-3">{t.kvkk_sec3Title}</h3>
                <p className="text-gray-300 mb-3">{t.kvkk_sec3Intro}</p>
                <ul className="space-y-2 text-gray-300">
                  {t.kvkk_sec3Items.map((item, index) => (
                    <li key={index} className="flex items-start">
                      <span className="text-[#FFDD59] mr-2">—</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* 4. Saklama Suresi */}
              <div className="mb-6 bg-gray-900/50 border border-gray-700 p-6 rounded-lg">
                <h3 className="text-lg font-bold text-[#FFDD59] mb-3">{t.kvkk_sec4Title}</h3>
                <p className="text-gray-300 mb-3">{t.kvkk_sec4Intro}</p>
                <ul className="space-y-2 text-gray-300 mb-4">
                  {t.kvkk_sec4Items.map((item, index) => (
                    <li key={index} className="flex items-start">
                      <span className="text-[#FFDD59] mr-2">—</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
                <p className="text-gray-300 leading-relaxed pt-3 border-t border-gray-700 italic">{t.kvkk_sec4Note}</p>
              </div>

              {/* 5. KVKK Md. 11 Haklar */}
              <div className="mb-6 bg-gray-900/50 border border-gray-700 p-6 rounded-lg">
                <h3 className="text-lg font-bold text-[#FFDD59] mb-3">{t.kvkk_sec5Title}</h3>
                <p className="text-gray-300 mb-3">{t.kvkk_sec5Text}</p>
                <ul className="space-y-2 text-gray-300">
                  {t.kvkk_sec5Items.map((item, index) => (
                    <li key={index} className="flex items-start">
                      <span className="text-[#FFDD59] mr-2">—</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* 6. Basvuru Yontemleri ve Kimlik Dogrulama */}
              <div className="mb-6 bg-gray-900/50 border border-gray-700 p-6 rounded-lg">
                <h3 className="text-lg font-bold text-[#FFDD59] mb-3">{t.kvkk_sec6Title}</h3>
                <p className="text-gray-300 mb-3">{t.kvkk_sec6Intro}</p>
                <ul className="space-y-2 text-gray-300 mb-4">
                  {t.kvkk_sec6Items.map((item, index) => (
                    <li key={index} className="flex items-start">
                      <span className="text-[#FFDD59] mr-2">—</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
                <p className="text-gray-300 leading-relaxed pt-3 border-t border-gray-700 italic">{t.kvkk_sec6Note}</p>
              </div>
            </div>

            {/* Company Info */}
            <div className="mb-8 bg-gray-900 border border-[#FFDD59]/30 p-6 rounded-lg">
              <p className="text-white font-semibold mb-2">{t.companyInfo}</p>
              <p className="text-gray-300 mb-1">{t.address}</p>
              <p className="text-gray-300 mb-4">{t.mersis}</p>
              <p className="text-gray-300 text-base leading-relaxed pt-4 border-t border-gray-700">
                {t.intro}
              </p>
            </div>

            {/* Section 1 */}
            <div className="mb-6 bg-gray-900/50 border border-gray-700 p-6 rounded-lg">
              <h2 className="text-lg font-bold text-[#FFDD59] mb-3">{t.section1Title}</h2>
              <p className="text-gray-300 mb-3">{t.section1Text}</p>
              <ul className="space-y-2 text-gray-300">
                {t.section1Items.map((item, index) => (
                  <li key={index} className="flex items-start">
                    <span className="text-[#FFDD59] mr-2">—</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Section 2 */}
            <div className="mb-6 bg-gray-900/50 border border-gray-700 p-6 rounded-lg">
              <h2 className="text-lg font-bold text-[#FFDD59] mb-3">{t.section2Title}</h2>
              <p className="text-gray-300 mb-3">{t.section2Text}</p>
              <ul className="space-y-2 text-gray-300">
                {t.section2Items.map((item, index) => (
                  <li key={index} className="flex items-start">
                    <span className="text-[#FFDD59] mr-2">—</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Section 3 */}
            <div className="mb-6 bg-gray-900/50 border border-gray-700 p-6 rounded-lg">
              <h2 className="text-lg font-bold text-[#FFDD59] mb-3">{t.section3Title}</h2>
              <p className="text-gray-300">{t.section3Text}</p>
            </div>

            {/* Section 4 */}
            <div className="mb-6 bg-gray-900/50 border border-gray-700 p-6 rounded-lg">
              <h2 className="text-lg font-bold text-[#FFDD59] mb-3">{t.section4Title}</h2>
              <p className="text-gray-300">{t.section4Text}</p>
            </div>

            {/* Section 5 */}
            <div className="mb-6 bg-gray-900/50 border border-gray-700 p-6 rounded-lg">
              <h2 className="text-lg font-bold text-[#FFDD59] mb-3">{t.section5Title}</h2>
              <p className="text-gray-300 mb-3">{t.section5Text}</p>
              <ul className="space-y-2 text-gray-300">
                {t.section5Items.map((item, index) => (
                  <li key={index} className="flex items-start">
                    <span className="text-[#FFDD59] mr-2">—</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Section 6 */}
            <div className="mb-6 bg-gray-900/50 border border-gray-700 p-6 rounded-lg">
              <h2 className="text-lg font-bold text-[#FFDD59] mb-3">{t.section6Title}</h2>
              <p className="text-gray-300">{t.section6Text}</p>
            </div>

            {/* === Acik Riza Beyani (yeni — sayfanin altinda, anchor'li) === */}
            {/* Influencer formundaki Acik Riza checkbox'inin "(Detaylari okuyun)" linki bu section'a scroll eder. */}
            {/* scroll-mt-24: anchor'a scroll edince navbar altinda kalmasin. */}
            <section
              id={language === 'tr' ? 'acik-riza' : 'explicit-consent'}
              className="mt-12 scroll-mt-24"
            >
              <h2 className="text-xl md:text-2xl font-bold text-[#FFDD59] mb-4">{t.acikRiza_title}</h2>
              <p className="text-gray-300 mb-4">{t.acikRiza_intro}</p>
              <div className="bg-yellow-400/10 border-l-4 border-yellow-400 p-6 my-4 rounded-r-lg">
                <p className="text-gray-200 whitespace-pre-line leading-relaxed">{t.acikRiza_text}</p>
              </div>
              <p className="text-sm text-gray-400 italic">{t.acikRiza_note}</p>
              <p className="text-xs text-gray-500 mt-2">{t.acikRiza_textVersion}</p>
            </section>

            {/* Last Update */}
            <p className="text-center text-gray-500 text-sm mt-8">{t.lastUpdate}</p>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
